const ADMIN_USER_FOR_IMPERSONATION_UPDATED = (state, userId) => {
  state.userForImpersonation = userId
}

const ADMIN_NEW_USER_PASSWORD_UPDATED = (state, newPassword) => {
  state.usersNewPassword = newPassword
}

export default {
  ADMIN_USER_FOR_IMPERSONATION_UPDATED,
  ADMIN_NEW_USER_PASSWORD_UPDATED,
}
